import { render } from "./BenefitA.vue?vue&type=template&id=1fc14cc7&scoped=true"
import script from "./BenefitA.vue?vue&type=script&lang=js"
export * from "./BenefitA.vue?vue&type=script&lang=js"

import "./BenefitA.vue?vue&type=style&index=0&id=1fc14cc7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc14cc7"]])

export default __exports__